/**
 * Shared signer color palette.
 *
 * Provides both Tailwind classes (for task pane UI) and hex values
 * (for Office.js Shape fills / Content Control borders).
 * Used by SignatureFieldPlacer, useSignatureShapes, and useSignatureControls.
 */

export interface SignerColor {
  /** Tailwind background class */
  bg: string
  /** Tailwind text class */
  text: string
  /** Tailwind border class */
  border: string
  /** Primary hex color (border / text in shapes) */
  hex: string
  /** Light hex color (shape fill background) */
  hexLight: string
}

export const SIGNER_COLORS: SignerColor[] = [
  {
    bg: 'bg-indigo-50 dark:bg-indigo-900/20',
    text: 'text-indigo-600 dark:text-indigo-400',
    border: 'border-indigo-200 dark:border-indigo-800',
    hex: '#4F46E5',
    hexLight: '#EEF2FF',
  },
  {
    bg: 'bg-amber-50 dark:bg-amber-900/20',
    text: 'text-amber-600 dark:text-amber-400',
    border: 'border-amber-200 dark:border-amber-800',
    hex: '#D97706',
    hexLight: '#FFFBEB',
  },
  {
    bg: 'bg-green-50 dark:bg-green-900/20',
    text: 'text-green-600 dark:text-green-400',
    border: 'border-green-200 dark:border-green-800',
    hex: '#059669',
    hexLight: '#ECFDF5',
  },
  {
    bg: 'bg-pink-50 dark:bg-pink-900/20',
    text: 'text-pink-600 dark:text-pink-400',
    border: 'border-pink-200 dark:border-pink-800',
    hex: '#DB2777',
    hexLight: '#FDF2F8',
  },
  {
    bg: 'bg-sky-50 dark:bg-sky-900/20',
    text: 'text-sky-600 dark:text-sky-400',
    border: 'border-sky-200 dark:border-sky-800',
    hex: '#0284C7',
    hexLight: '#F0F9FF',
  },
]

export function getSignerColor(index: number): SignerColor {
  return SIGNER_COLORS[index % SIGNER_COLORS.length]
}
